import {useNavigate} from "react-router-dom";
import {useCallback} from "react";

const nonClickableCellsTypes = ['email', 'phone', 'buttons', 'audio_player', 'link', 'link_list']
export default function useCellNavigation(
    type:string,
    row: {[key: string]: any},
    page?:string | null,
    filterable?:boolean
) {
    const navigate = useNavigate()

    const isDataAsHref = !(nonClickableCellsTypes.includes(type) || filterable) && page

    const handleCellClick = useCallback(() => {
        const navigateToInfoPage = row?.row_href_type === 'info'
        return isDataAsHref
            ? navigate(`${page}/${navigateToInfoPage ? 'info' : 'update'}/${row.id}`)
            : null
    }, [isDataAsHref, page, row])

    return { isDataAsHref, handleCellClick, navigate  }
}